import { ReactComponent as CheckboxCheckDisabled } from '@/assets/svgs/checkbox-button-check-disabled.svg';
import { ReactComponent as CheckboxCheck } from '@/assets/svgs/checkbox-button-check.svg';
import { ReactComponent as CheckboxPartial } from '@/assets/svgs/checkbox-button-partial.svg';
import { ReactComponent as CheckboxUncheckDisabled } from '@/assets/svgs/checkbox-button-uncheck-disabled.svg';
import { ReactComponent as CheckboxUncheck } from '@/assets/svgs/checkbox-button-uncheck.svg';
import classname from 'classnames';
import { uniqueId } from 'lodash';


export const types = {
	check: true,
	uncheck: false,
	partial: 'partial',
};

export const CheckButtonDesign = ({ check, disabled }) => {
	if (!disabled) {
		if (check === types.check) {
			return <CheckboxCheck data-testid="checkbox-check" />;
		}

		if (check === types.partial) {
			return <CheckboxPartial data-testid="checkbox-partial" />;
		}

		if (check === types.uncheck) {
			return <CheckboxUncheck data-testid="checkbox-uncheck" />;
		}
	}

	if (disabled) {
		if (check === types.check) {
			return <CheckboxCheckDisabled data-testid="checkbox-check-disabled" />;
		}

		if (check === types.uncheck) {
			return <CheckboxUncheckDisabled data-testid="checkbox-uncheck-disabled" />;
		}
	}

	return null;
};

const CheckboxButton = ({ check, name, disabled, submit, ...inputCheckbox }) => {
	const id = uniqueId();

	const checkboxClass = classname(inputCheckbox.className, {
		'checkbox-button': true,
		'checkbox-button--disabled': disabled,
	});

	const checkboxIcon = classname("checkbox-button__button", {
		'checkbox-button__button--svg-check': check===types.check,
		'checkbox-button__button--svg-partial': check===types.partial,
		'checkbox-button__button--svg-uncheck': check===types.uncheck,
	})

	return (
		<label className={checkboxClass} htmlFor={id}>
			<input
				data-testid="checkbox-input"
				type="checkbox"
				className="checkbox-button__input"
				checked={check === types.check}
				onChange={(e) => {
					disabled ? e.preventDefault() : submit(e);
				}}
				{...inputCheckbox}
				disabled={disabled}
				id={id}
			/>

			<span className={checkboxIcon}>
				<CheckButtonDesign check={check} disabled={disabled} />
			</span>
			<span className="checkbox-button__text">{name}</span>
		</label>
	);
};

export default CheckboxButton;
